import { PLAN_TYPES, PLANS_HIERARCHY } from 'src/constants/cardsEnum';

export function isPlanAtLeast(
  currentPlan: keyof typeof PLAN_TYPES,
  benchmarkPlan: keyof typeof PLAN_TYPES,
): boolean {
  return (
    PLANS_HIERARCHY.indexOf(currentPlan) >=
    PLANS_HIERARCHY.indexOf(benchmarkPlan)
  );
}
